export const TOKEN_STORAGE_KEY = "kj-admin-token";
